import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

// Console-polyfill. MIT license.
// https://github.com/paulmillr/console-polyfill
// Make it safe to do console.log() always.
(function (global) {
    'use strict';
    if (!global.console) {
        global.console = {};
    }
    var con = global.console;
    var prop, method;
    var dummy = function () {};
    var properties = ['memory'];
    var methods = (
        'assert,clear,count,debug,dir,dirxml,error,exception,group,' +
        'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
        'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn,timeLog,trace'
    ).split(',');
    while ((prop = properties.pop())) if (!con[prop]) con[prop] = {};
    while ((method = methods.pop())) if (!con[method]) con[method] = dummy;

    // defining system time in the Date object
    Object.defineProperty(global.Date, 'systemNow', {
        value: Date.now,
    });

    // Using `this` for web workers & supports Browserify / Webpack.
})(typeof window === 'undefined' ? this : window);

(async () => {
    if ('ResizeObserver' in window === false) {
        // Loads polyfill asynchronously, only if required.
        const module = await import('@juggle/resize-observer');
        window.ResizeObserver = module.ResizeObserver;
    }
})();
